import ReactGA from 'react-ga4';

// Replace 'G-XXXXXXXXXX' with your Google Analytics 4 Measurement ID
// You can find this in your Google Analytics account under Admin > Data Streams
const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID || 'G-XXXXXXXXXX';

// Initialize Google Analytics
export const initGA = () => {
  if (GA_MEASUREMENT_ID && GA_MEASUREMENT_ID !== 'G-XXXXXXXXXX') {
    ReactGA.initialize(GA_MEASUREMENT_ID);
    console.log('Google Analytics initialized');
  } else {
    console.warn('Google Analytics Measurement ID not set. Please set REACT_APP_GA_MEASUREMENT_ID in your .env file');
  }
};

// Track page views
export const trackPageView = (path) => {
  if (GA_MEASUREMENT_ID && GA_MEASUREMENT_ID !== 'G-XXXXXXXXXX') {
    ReactGA.send({ hitType: 'pageview', page: path });
  }
};

// Track custom events
export const trackEvent = (eventName, eventParams = {}) => {
  if (GA_MEASUREMENT_ID && GA_MEASUREMENT_ID !== 'G-XXXXXXXXXX') {
    ReactGA.event(eventName, eventParams);
  }
};
